module.exports = __webpack_public_path__ + "assets/img/5_1166_big.874ea975.jpg";